/* action type */
export const VIEW_DATA_OBJECT = 'VIEW_DATA_OBJECT';

/* action creator */
export const getDataObjectViewAction = (actionPayload: any) => {
  return {
    type: VIEW_DATA_OBJECT,
    payload: actionPayload
  };
};
